import React, { useState, useRef } from 'react';
import { connect, useDispatch } from "react-redux";
import { change, Field, Form as ReduxForm, reduxForm } from "redux-form";
import { Input, Dropdown, Row, Col, Checkbox, Radio } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useWindowSize from '../../utils/resizeHook';
import resetCpayIcon from '../../img/cpay-svg/reset.svg';
import resetNfgIcon from '../../img/nfgpay-svg/reset-nfg.svg';
import resetFinvaroIcon from '../../img/finvaro/reset-finvaro.svg';
import resetClarniumIcon from '../../img/clarnium/reset-clarnium.svg';
import resetInexIcon from '../../img/inex/reset-inex.svg';
import resetInstaIcon from "../../img/instaXchange/reset-insta.svg";
import resetCoineraIcon from "../../img/coinera/reset-coinera.svg";
import './WalletsFilters.scss';
import { identity } from '../../utils/getIdentity';

const resetIcon = {
  cpay: resetCpayIcon,
  nfg: resetNfgIcon,
  finvaro: resetFinvaroIcon,
  clarnium: resetClarniumIcon,
  inex: resetInexIcon,
  insta: resetInstaIcon,
  coinera: resetCoineraIcon
}

const RenderSearch = ({ input, placeholder, onSearch, className, addonAfter, disabled }) => {
  return (
    <Input.Search
      disabled={disabled}
      {...input}
      placeholder={placeholder}
      onSearch={onSearch}
      className={className}
      addonAfter={addonAfter}
    />
  );
};

const RenderCheckbox = ({ input, options, disabled }) => {
  return <Checkbox.Group disabled={disabled} {...input} options={options} />;
};

const RenderRadio = ({ input, options, disabled }) => {
  return (
    <Radio.Group disabled={disabled} {...input}>
      {options.map((option, index) => (
        <Radio key={index} value={option.value}>
          {option.label}
        </Radio>
      ))}
    </Radio.Group>
  );
};

const ClientsWalletsFilters = ({ submitFilters, currencies, resetFilters, fetching, merchantName, hideZeroCheckbox, setCheckbox, formName }) => {
  const [isCurrenciesVisible, setIsCurrenciesVisible] = useState(false);
  const [isSortingVisible, setIsSortingVisible] = useState(false);
  const [currencyArray, setCurrencyArray] = useState();
  const { currentWidth } = useWindowSize();
  const formRef = useRef(null);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const language = localStorage.getItem('cpayAppLang');

  const handleSelectAll = () => {
    const allValues = currencies.map(currency => currency._id);
    dispatch(change(formName, "currencyIds", allValues));
  };

  const handleClearAll = () => {
    dispatch(change(formName, "currencyIds", []));
  };

  const handleReset = () => {
    formRef.current.props._reduxForm.reset();
    resetFilters();
  };

  return (
    <ReduxForm ref={formRef} onSubmit={e => e.preventDefault()}>
      <div className="wallet-filters">
        <Row gutter={[20]}>
          <Col span={currentWidth >= 1024 ? 11 : 24} className="component__title wallet-filters__title">
            {t('merchants.merchant')} {merchantName} {t('merchants.clientWallets').toLowerCase()}
          </Col>
          <Col span={currentWidth >= 1024 ? 7 : 24} className="wallet-filters__search">
            <Field
              disabled={fetching}
              name="search"
              component={RenderSearch}
              placeholder={t("wallets.placeholder")}
              onSearch={submitFilters}
              onFocus={e => e.preventDefault()}
              onBlur={e => e.preventDefault()}
              className="wallet-filters__search-field"
              addonAfter={
                <span onClick={handleReset} className="wallet-filters__reset-button">
                  <img src={resetIcon[identity]} alt="Reset" />
                </span>
              }
            />
          </Col>
          <Col span={currentWidth >= 1024 ? 3 : 12} className="wallet-filters__currencies">
            <Dropdown
              onVisibleChange={visibilityState => setIsCurrenciesVisible(visibilityState)}
              visible={isCurrenciesVisible}
              overlay={
                <div className={`wallet-filters__currencies-dropdown wallet-filters__currencies-dropdown-${identity}`}>
                  <div className="wallet-filters__currencies-select">
                    <div
                      className={`wallet-filters__currencies-select-all wallet-filters__currencies-select-all-${identity}`}
                      onClick={handleSelectAll}
                    >
                      {t("selectAll")}
                    </div>
                    <div
                      className={`wallet-filters__currencies-select-clear wallet-filters__currencies-select-clear-${identity}`}
                      onClick={handleClearAll}
                    >
                      {t('clearAll')}
                    </div>
                  </div>
                  <Field
                    disabled={fetching}
                    name="currencyIds"
                    options={currencies.map(currency => ({ label: currency.title, value: currency._id }))}
                    component={RenderCheckbox}
                    onFocus={e => e.preventDefault()}
                    onBlur={e => e.preventDefault()}
                  />
                  <div className={`wallet-filters__currencies-dropdown_apply wallet-filters__currencies-dropdown_apply-${identity}`} onClick={!fetching && submitFilters}>
                    {t('apply')}
                  </div>
                </div>
              }
            >
              <div className={`wallet-filters__currencies-button wallet-filters__currencies-button-${identity}`}>
                {t('currency')} <DownOutlined />
              </div>
            </Dropdown>
          </Col>
          <Col span={currentWidth >= 1024 ? 3 : 12} className="wallet-filters__sorting">
            <Dropdown
              onVisibleChange={visibilityState => setIsSortingVisible(visibilityState)}
              visible={isSortingVisible}
              overlay={
                <div className={`wallet-filters__currencies-dropdown wallet-filters__currencies-dropdown-${identity}`}>
                  <Field
                    disabled={fetching}
                    name="order"
                    options={[
                      { label: t('first'), value: 'DESC' },
                      { label: t('last'), value: 'ASC' },
                    ]}
                    component={RenderRadio}
                    onFocus={e => e.preventDefault()}
                    onBlur={e => e.preventDefault()}
                  />
                  <div className="wallet-filters__currencies-zero">
                    <Checkbox
                      checked={hideZeroCheckbox}
                      onChange={() => {
                        localStorage.setItem('cpayHideZeroBalancesClient', !hideZeroCheckbox);
                        setCheckbox(!hideZeroCheckbox)}
                      }
                    >
                      {t('homePage.transactions.zeroBal')}
                    </Checkbox>
                  </div>
                </div>
              }
            >
              <div className={`wallet-filters__currencies-button wallet-filters__currencies-button-${identity}`}>
                {t('sorting')} <DownOutlined />
              </div>
            </Dropdown>
          </Col>
        </Row>
      </div>
    </ReduxForm>
  );
};

const FiltersFormContainer = reduxForm({ destroyOnUnmount: true })(ClientsWalletsFilters);

export default connect((state, { formName }) => ({
  form: formName
}))(FiltersFormContainer);
